import { render, staticRenderFns } from "./ArchiveComment.vue?vue&type=template&id=2d617218&scoped=true&lang=pug&"
import script from "./ArchiveComment.vue?vue&type=script&lang=js&"
export * from "./ArchiveComment.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveComment.scss?vue&type=style&index=0&id=2d617218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d617218",
  null
  
)

export default component.exports